.paper {
  padding: 20px;
  margin: 20px;
}

.title {
  margin-bottom: 20px;
}

@media (min-width: 640px) {
  .paper {
    position: fixed;
    bottom: 30px;
    right: 30px;
  }
}
